import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';
import type {
  MailchimpImportRequest,
  MailchimpImportResult,
} from '../../functions/src/importMailchimp';

const functions = getFunctions(app, 'us-central1');

/**
 * Fetch a Mailchimp campaign by its public "View in browser" archive URL.
 * Returns the raw archive HTML (cleaned further in the browser) and subject.
 */
export async function importMailchimpCampaign(
  url: string,
): Promise<MailchimpImportResult> {
  const callable = httpsCallable<MailchimpImportRequest, MailchimpImportResult>(
    functions,
    'importMailchimpCampaign',
  );
  const response = await callable({ url });
  return response.data;
}
